import { googleAnalytics } from "../gtag";
import { facebookPixel } from "../facebookPixel";
import { pinterestAnalytics } from "../pinterest";

export function generateLead() {
  googleAnalytics("event", "generate_lead");
  facebookPixel("track", "Lead");
  pinterestAnalytics("track", "lead");
}
